// libs
import { styled } from '@nykaa/ui-components';

// constants
import { MWEB_HEADER_HEIGHT } from 'shared/styles/base';

export const Container = styled.div<{
  allowPadding: boolean;
  isRewardsPageEnabled: boolean;
}>`
  ${({ allowPadding, isRewardsPageEnabled }) =>
    allowPadding && `padding-top: ${isRewardsPageEnabled ? '112' : MWEB_HEADER_HEIGHT}px`};
`;
